import React from "react";
import SectionLabel from "./SectionLabel";

const ExperienceList = ({ title, items }) => {
  return (
    <section className="scroll-mt-24">
      <SectionLabel>{title}</SectionLabel>
      <ul className="m-0 flex list-none flex-col gap-3 p-0">
        {items.map((item) => {
          const company = item.href ? (
            <a
              href={item.href}
              target="_blank"
              rel="noopener noreferrer"
              className="truncate text-[15px] font-medium text-zinc-950 hover:underline underline-offset-2 dark:text-zinc-50"
            >
              {item.company}
            </a>
          ) : (
            <div className="truncate text-[15px] font-medium text-zinc-950 dark:text-zinc-50">
              {item.company}
            </div>
          );

          return (
            <li
              key={item.id}
              tabIndex={0}
              className="group -mx-2 cursor-pointer rounded-lg px-2 py-1.5 transition-colors hover:bg-zinc-950/[0.03] focus-within:bg-zinc-950/[0.03] dark:hover:bg-white/[0.03] dark:focus-within:bg-white/[0.03]"
            >
              <div className="flex items-start justify-between gap-6 max-sm:flex-col max-sm:gap-1">
                <div className="flex min-w-0 items-start gap-3">
                  <div className="flex h-12 w-12 shrink-0 items-center justify-center">
                    {item.href ? (
                      <a
                        href={item.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label={item.company}
                        className="flex h-full w-full items-center justify-center"
                      >
                        <img
                          src={item.logo}
                          alt=""
                          className={`object-contain opacity-90 grayscale ${
                            item.logoWide ? "h-[22px] w-9" : "h-7 w-7"
                          }`}
                        />
                      </a>
                    ) : (
                      <img
                        src={item.logo}
                        alt=""
                        className={`object-contain opacity-90 grayscale ${
                          item.logoWide ? "h-[22px] w-9" : "h-7 w-7"
                        }`}
                      />
                    )}
                  </div>
                  <div className="min-w-0">
                    {company}
                    <div className="mt-0.5 truncate text-[13px] text-zinc-600 dark:text-zinc-400">
                      {item.role}
                      {item.stack ? (
                        <>
                          <span className="mx-1 text-zinc-500">·</span>
                          {item.stack}
                        </>
                      ) : null}
                    </div>
                  </div>
                </div>
                <div className="shrink-0 pt-0.5 text-[13px] text-zinc-500 whitespace-nowrap max-sm:whitespace-normal">
                  {item.timeframe}
                </div>
              </div>
              {item.blurb ? (
                <p className="ml-[60px] mt-0 grid grid-rows-[0fr] opacity-0 -translate-y-1 transition-[grid-template-rows,opacity,transform,margin] duration-300 ease-out max-sm:ml-0 group-hover:mt-2 group-hover:grid-rows-[1fr] group-hover:opacity-100 group-hover:translate-y-0 group-focus-within:mt-2 group-focus-within:grid-rows-[1fr] group-focus-within:opacity-100 group-focus-within:translate-y-0 motion-reduce:transition-none">
                  <span className="min-h-0 overflow-hidden text-[13px] leading-relaxed text-zinc-500 max-w-xl">
                    <span className="mr-1.5 text-zinc-400">↳</span>
                    {item.blurb}
                  </span>
                </p>
              ) : null}
            </li>
          );
        })}
      </ul>
    </section>
  );
};

export default ExperienceList;
